module.exports = __webpack_public_path__ + "img/onboarding.08ed5d38.svg";